import React, { useEffect } from 'react';
import qs from 'qs';
import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import featuresConfig from '@front/common/src/config/features.json';
import { FeatureConfig, FeatureKey } from '@front/common/src/types/commons';
import { enableAbFeature, disableAbFeature } from '@front/common/src/ducks/common/ab-features';

const featureRegex = /[+-]([a-zA-Z0-9_]+)/g;
type SetupFeaturesProps = {
  rootPath: string;
};

// Component used in multiple web packages
// This ab test feature logic will be removed and completely replaced in the future.
export const SetupFeatures = ({ rootPath }: SetupFeaturesProps) => {
  const location = useLocation();
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
  const dispatch = useDispatch();

  useEffect(() => {
    location.pathname.match(featureRegex)?.forEach((result) => {
      const feature = result.substring(1) as FeatureKey;
      const featureConfig: FeatureConfig = featuresConfig[feature];
      if (typeof featureConfig === 'object' && featureConfig.isAbTestable) {
        if (result.startsWith('+')) {
          dispatch(enableAbFeature(feature as FeatureKey));
        } else if (result.startsWith('-')) {
          dispatch(disableAbFeature(feature as FeatureKey));
        }
      } else {
        dispatch(disableAbFeature(feature as FeatureKey));
      }
    });
  }, [dispatch, location.pathname]);

  // We do the redirection by preserving the search query params in the URL,
  // to keep query params like referring pro after redirection
  return (
    <Navigate
      to={{
        ...location,
        search: qs.stringify({
          // Preserve existing query params...
          ...queryParams,
          // ...but add an ab parameter here
          // to acknowledge that the A/B features have been taken into account.
          // This lets us configure PageSense Split URLs,
          // to prevent endlessly redirecting to an A or B test case
          ab: 1,
        }),
        pathname: rootPath,
      }}
      replace
    />
  );
};

export default SetupFeatures;
